import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CheckListComponent } from '../../../shared-components/check-list/check-list.component';

const ORDINALS = ['1st', '2nd', '3rd', '4th'];

@Component({
  selector: 'kpi-dimension-card',
  standalone: true,
  imports: [ReactiveFormsModule, CheckListComponent],
  templateUrl: './kpi-dimension-card.component.html',
  styleUrls: ['./kpi-dimension-card.component.less'],
})
export class KpiDimensionCardComponent {
  @Input() heading = '';
  @Input() caption = '';
  @Input() enabled = false;
  @Input() order = 0;
  @Input() positions: number[] = [];
  @Input() dimensionName = '';
  @Input() dimensionNames: string[] = [];
  @Input() items: Dimension[] = [];
  @Input() editable = false;
  @Input({ required: true }) control!: FormControl;

  @Output() enabledChange = new EventEmitter<boolean>();
  @Output() orderChange = new EventEmitter<number>();
  @Output() dimensionNameChange = new EventEmitter<string>();

  get emptyText(): string {
    if (!this.enabled) {
      return 'Dimension not used';
    }
    return this.dimensionName ? 'No values available' : 'Select a dimension first';
  }

  ordinal(position: number): string {
    return ORDINALS[position - 1] ?? `${position}th`;
  }

  onEnabledChange(event: Event): void {
    this.enabledChange.emit((event.target as HTMLInputElement).checked);
  }

  onOrderChange(event: Event): void {
    this.orderChange.emit(Number((event.target as HTMLSelectElement).value));
  }

  onDimensionNameChange(event: Event): void {
    this.dimensionNameChange.emit((event.target as HTMLSelectElement).value);
  }
}
